// extracted by mini-css-extract-plugin
var _1 = "amount-oGu2D";
var _2 = "comparison-SkC8a";
var _3 = "discount-Unloo";
var _4 = "options-OWTWE";
var _5 = "price-IHRLZ";
var _6 = "sale-dWDoz";
var _7 = "throw-wgJNz";
var _8 = "wrapper-SRd2e";
export { _1 as "amount", _2 as "comparison", _3 as "discount", _4 as "options", _5 as "price", _6 as "sale", _7 as "throw", _8 as "wrapper" }
